import {css, cx}                from "emotion";
import {rgba}                   from "polished";
import * as React               from "react";

import "./branch-switcher.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";

import {BranchSwitcherModal} from "../../../../../common/branch-switcher-modal/branch-switcher-modal";

export const BranchSwitcher = ({hidden}) => cs(
    consumeContext("userLevels"),

    ({userLevels}, next) => userLevels?.multiBranch && next(),

    consumeContext("session"),
    consumeContext("themeScheme"),

    ["branchSwitcherModal", (_, next) => BranchSwitcherModal({next})],

    ({themeScheme, branchSwitcherModal, session}) => (
        <div
            className={cx(
                "branch-switcher branch-switcher-5tf", {hidden},
                css`
                    & > .branchSwitcher {
                        color: ${themeScheme.xpresso.menuTextColor};
                        border: 1px solid ${rgba(themeScheme.xpresso.menuTextColor, .4)};
                        
                        & > .officeButton {
                            color: ${themeScheme.xpresso.menuBackgroundColor};
                            background: ${rgba(themeScheme.xpresso.menuTextColor, .6)};
                            
                            &:hover {
                                background: ${rgba(themeScheme.xpresso.menuTextColor, .8)};
                            }
                        }
                    }
                `
            )}
        >
            {(() => {
                const label = session.loading ? "Loading..." : session.data.branchName;

                return (
                    <div className="branchSwitcher"
                        onClick={() => branchSwitcherModal.show()}
                        title={label}
                        xd-qa-type="button"
                        xd-qa-name="Selection"
                    >
                        <div className="officeLabel" xd-qa-type="label" xd-qa-name={label}>
                            {label}
                        </div>
                        <div className="officeButton">
                            Change
                        </div>
                    </div>
                )
            })()}
        </div>
    ),
);
